import { RouteComponentProps } from 'react-router-dom'
import { connect } from 'react-redux'
import { IStoreState, IUpdateVehicleAccessAndCapacity } from '../../types'
import AccessAndCapacity from '../../components/vehicles/edit-vehicle/AccessAndCapacity'
import { actionCreators, getSingleVehicle, updateVehicleCapacity } from '../../state/actions/vehicles'

const mapStateToProps = (nextStep: string) => (state: IStoreState, ownProps: RouteComponentProps<{ id: string }>) => {
  return {
    ...ownProps,
    isSaved: state.vehicles.isSaved,
    vehicle: state.vehicles.items[ownProps.match.params.id],
    isRequesting: state.vehicles.isLoading,
    nextStep
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateVehicleCapacity: (data: IUpdateVehicleAccessAndCapacity) => dispatch(updateVehicleCapacity(data)),
    getVehicleById: (id: string) => dispatch(getSingleVehicle(id)),
    setVehicleSavedStateToInitial: () => dispatch(actionCreators.setVehicleSavedStateToInitial())
  }
}

export default (nextStep: string) =>
  connect(
    mapStateToProps(nextStep),
    mapDispatchToProps
  )(AccessAndCapacity)



// WEBPACK FOOTER //
// ./src/containers/vehicles/AccessAndCapacity.ts